module.exports = __webpack_public_path__ + "static/media/di-rect.424cba7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/clients/di-rect.jpg
// module id = 280
// module chunks = 0